import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05e1b779"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-collections-top" }
const _hoisted_2 = {
  key: 0,
  class: "my-collections-top-fullname mt-4"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "guide-content mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputDebounce = _resolveComponent("InputDebounce")!
  const _component_IconText = _resolveComponent("IconText")!
  const _component_MyCollectionsNotLogged = _resolveComponent("MyCollectionsNotLogged")!
  const _component_CollectionsTop = _resolveComponent("CollectionsTop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CollectionsTop, null, {
      default: _withCtx(() => [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.isEditing)
                ? (_openBlock(), _createBlock(_component_InputDebounce, {
                    key: 0,
                    modelValue: _ctx.fullName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput($event))),
                    placeholder: _ctx.$t('collection.full-name'),
                    loading: _ctx.loadingEdit
                  }, null, 8, ["modelValue", "placeholder", "loading"]))
                : _createCommentVNode("", true),
              (!_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("h2", {
                    key: 1,
                    class: _normalizeClass({ 'mr-5': _ctx.fullName })
                  }, _toDisplayString(_ctx.fullName), 3))
                : _createCommentVNode("", true),
              (!_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEditing = true)),
                    class: "btn gossamer py-2 px-3"
                  }, [
                    _createVNode(_component_IconText, null, {
                      icon: _withCtx(() => [
                        _hoisted_3
                      ]),
                      text: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("collection.edit-your-full-name")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn gossamer py-3 px-3 ml-5",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleGuide && _ctx.toggleGuide(...args)))
              }, _toDisplayString(_ctx.$t("collection.guide-to-my-collections")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showGuide)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_MyCollectionsNotLogged)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}